
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advertising-materials",
      function () {
        return require("private-next-pages/advertising-materials.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advertising-materials"])
      });
    }
  